export default "__VITE_ASSET__BDjqIqt$__"